import {
  UserActionTypes,
  SET_USER,
  User,
  UserDetails,
  USER_LOGOUT,
  AddressProps,
  LocationState,
  SET_CURRENT_LOCATION,
  SET_FILTER_DATA,
  FilterData,
  Ratings,
  SET_USER_RATING,
  SET_USER_PROVIDER,
} from './types';

const addressState: AddressProps = {
  street: '',
  city: '',
  note: '',
};

const locState: LocationState = {
  lat: 0,
  lng: 0,
};

const filterdataState: FilterData = {
  isFilter: false,
  category: [],
  restrictions: [],
  distance: 0,
  // consumption: '',
  // price: 0,
  selectedDate: {
    from: '',
    to: '',
  },
  constantOffer: false,
};

const userDetails: UserDetails = {
  userid: '',
  accountType: '',
  subAccountType: '',
  email: '',
  firstName: '',
  lastName: '',
  username: '',
  description: '',
  phone: '',
  address: addressState,
  image: '',
  status: '',
  location: locState,
};

const rates: Ratings = {
  id: '',
  rate: 0,
  user: '',
};

const initialState: User = {
  user: userDetails,
  currentLocation: locState,
  dataFilter: filterdataState,
  ratings: [],
  providername: '',
};

export const userReducer = (state = initialState, action: UserActionTypes) => {
  const { type, user } = action;
  switch (type) {
    case SET_USER:
      return { ...state, user };
    case USER_LOGOUT:
      return initialState;
    case SET_CURRENT_LOCATION:
      return { ...state, currentLocation: action?.currentLocation };
    case SET_FILTER_DATA:
      return { ...state, dataFilter: action?.dataFilter };
    case SET_USER_RATING:
      return { ...state, ratings: action.ratings };
    case SET_USER_PROVIDER:
      return { ...state, providername: action.providername };
    default:
      return state;
  }
};
